<script lang="ts">
  import { MIN_EVENT_MINUTES } from "../../../../../../_shared/_logic/display-scale"
  import { addMinutes, setTime } from "../../../../../../../../../../../_shared/_logic/date-math"
  import type {
    BoardActions,
    BoardLayoutConfig,
    TimeSlot,
  } from "../../../../../../../../_logic/calendar-types"

  const {
    columnDay,
    employeeId,
    timeSlots = [],
    layout,
    nowTs,
    isPastDay = false,
    readOnly = false,
    allowSlotCreation = true,
    actions,
    onHoverChange = () => {},
  }: {
    columnDay: Date
    employeeId?: string
    timeSlots: TimeSlot[]
    layout: BoardLayoutConfig
    nowTs: number
    isPastDay?: boolean
    readOnly?: boolean
    allowSlotCreation?: boolean
    actions: BoardActions
    onHoverChange?: (value: number | null) => void
  } = $props()

  const slotHeight = $derived(layout.slotHeight)
  const slotMinutes = $derived(layout.slotMinutes)

  const slotIsPast = (minutes: number) => {
    if (isPastDay) return true

    const slotStart = setTime(columnDay, Math.floor(minutes / 60), minutes % 60)

    return slotStart.getTime() < nowTs
  }

  const slotIsDisabled = (_minutes: number) => readOnly || !allowSlotCreation
</script>

<div class="time-grid">
  {#each timeSlots.slice(0, -1) as slot, index (index)}
    <button
      type="button"
      class={`grid-row ${slotIsPast(slot.value) ? "past" : ""} ${readOnly ? "readonly" : ""}`}
      style={`height:${slotHeight}px`}
      aria-label={`Zeitfenster ${slot.ariaLabel}`}
      disabled={slotIsDisabled(slot.value)}
      onmouseenter={() => {
        if (slotIsDisabled(slot.value)) return

        onHoverChange(index)
      }}
      onmouseleave={() => onHoverChange(null)}
      onclick={() => {
        if (slotIsDisabled(slot.value)) return

        const slotStart = setTime(columnDay, Math.floor(slot.value / 60), slot.value % 60)
        const slotEnd = addMinutes(slotStart, MIN_EVENT_MINUTES)
        actions.addHardSlot({
          day: columnDay,
          dayTs: columnDay.getTime(),
          employeeId,
          startMinutes: slot.value,
          startAt: slotStart,
          endAt: slotEnd,
          startTs: slotStart.getTime(),
          endTs: slotEnd.getTime(),
        })
      }}
    ></button>
  {/each}
</div>

<style lang="less">
  .time-grid {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;

    .grid-row {
      border: none;
      background: none;
      padding: 0;
      margin: 0;
      width: 100%;
      border-bottom: 1px solid var(--cal-border, rgba(0, 0, 0, 0.06));
      flex-shrink: 0;
      transition:
        background 0.12s ease,
        border-color 0.12s ease;
      cursor: pointer;
      position: relative;

      &:hover {
        border-color: var(--column-accent, var(--cal-accent, #741e20));
      }

      &:hover::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--column-accent, var(--cal-accent, #741e20));
        opacity: 0.12;
        pointer-events: none;
      }

      &.past {
        background: color-mix(in srgb, var(--cal-text, #2f4858) 4%, transparent);
        cursor: pointer;
        border-color: color-mix(in srgb, var(--cal-border, rgba(0, 0, 0, 0.06)) 60%, transparent);
      }

      &.readonly {
        cursor: default;
        pointer-events: none;
      }

      &.readonly:hover {
        border-color: var(--cal-border, rgba(0, 0, 0, 0.06));
      }

      &.readonly:hover::after {
        display: none;
      }
    }
  }
</style>
